module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Light of the World")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#the-light-of-the-world"
    }
  }, [_vm._v("The Light of the World")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#listening-to-the-world",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Listening to the World")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#the-ground-beneath-us",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ground Beneath Us")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#protecting-the-world",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Protecting the World")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#instinct",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Instinct")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#a-word-without-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Word Without Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#within-us",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Within Us")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#the-sky-at-night",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sky at Night")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#the-world-and-all-its-people",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World and All Its People")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#seeing-from-within",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seeing from Within")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#inside-the-earth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Inside the Earth")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-pressures-of-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pressures of Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#the-beauty-of-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beauty of Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#will-the-world-become-a-peaceful-place",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Will the World Become a Peaceful Place?")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#the-world-at-night",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World at Night")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#energy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Energy")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#happiness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Happiness")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#all-around-us",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All Around Us")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#the-earth-beneath-us",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Earth Beneath Us")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#bringing-the-world-together",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bringing the World Together")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-world-is-a-mess",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World Is a Mess")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#upsetting-the-balance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Upsetting the Balance")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#whatever-happened-to-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whatever Happened to Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#nature-and-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nature and Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#good-things-are-coming",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Things Are Coming")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#repairing-our-world",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Repairing Our World")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#the-worlds-pandemic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The World’s Pandemic")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#a-wake-up-call",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Wake-Up Call")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#without-the-world",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Without the World")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#forever-young",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forever Young")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0